<template>
  <section class="table-sampler-validation-noise">
    <d-form-row class="mb-1">
      <d-col cols="3">
        <label>Amostra representativa</label>
        <select type="text" class="form-control" v-model="model.exposition" required>
          <option value="Sim" selected>Sim</option>
          <option value="Não">Não</option>
        </select>
      </d-col>
      <d-col cols="9">
        <label>Avaliação pessoal do trabalhador sobre exposição</label>
        <input
          type="text"
          class="form-control"
          placeholder="Avaliação"
          v-model="model.avaliation"
          required
        />
      </d-col>
    </d-form-row>
    <d-form-row class="mb-1">
      <d-col cols="3">
        <label>Tipo de amostra</label>
        <select type="text" class="form-control" v-model="model.exposition_type" required>
          <option value="Abaixo do normal" selected>Abaixo do normal</option>
          <option value="Normal">Normal</option>
          <option value="Acima do normal">Acima do normal</option>
        </select>
      </d-col>
      <d-col cols="9">
        <label>Justifique</label>
        <input
          type="text"
          class="form-control"
          placeholder="Justifique"
          v-model="model.justify"
          required
        />
      </d-col>
    </d-form-row>
    <h6 class="my-3">Calibração</h6>
    <d-form-row class="mb-1">
      <d-col cols="3">
        <label>Verificação inicial</label>
        <input
          type="text"
          class="form-control"
          placeholder="Verificação inicial"
          v-model="model.initial"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Tbs <small>(C˚)</small></label>
        <input
          type="text"
          class="form-control"
          placeholder="Tbs"
          v-model="model.initial_tbs"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Tbn <small>(C˚)</small></label>
        <input
          type="text"
          class="form-control"
          placeholder="Tbn"
          v-model="model.initial_tbn"
          required
        />
      </d-col>
       <d-col cols="3">
        <label>Tg <small>(C˚)</small></label>
        <input
          type="text"
          class="form-control"
          placeholder="Tg"
          v-model="model.initial_tg"
          required
        />
      </d-col>
    </d-form-row>
    <d-form-row class="mb-1">
      <d-col cols="3">
        <label>Verificação final</label>
        <input
          type="text"
          class="form-control"
          placeholder="Verificação final"
          v-model="model.final"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Tbs <small>(C˚)</small></label>
        <input
          type="text"
          class="form-control"
          placeholder="Tbs"
          v-model="model.final_tbs"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Tbn <small>(C˚)</small></label>
        <input
          type="text"
          class="form-control"
          placeholder="Tbn"
          v-model="model.final_tbn"
          required
        />
      </d-col>
       <d-col cols="3">
        <label>Tg <small>(C˚)</small></label>
        <input
          type="text"
          class="form-control"
          placeholder="Tg"
          v-model="model.final_tg"
          required
        />
      </d-col>
    </d-form-row>
  </section>
</template>

<script>
import Events from '_utils/events';
import { cloneDeep } from '_utils';
import { NOISE_VALIDATION, _LOAD_MODEL_ } from '../../SampleModel';

export default {
  name: 'Sample-Validation-Noise',
  props: {
    validation: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      model: cloneDeep(NOISE_VALIDATION),
    };
  },
  methods: {
    setModel() {
      if (this.validation) {
        this.model = this.validation;
      }
    },
  },
  mounted() {
    this.setModel();
    Events.$on(_LOAD_MODEL_, () => {
      this.setModel();
    });
  },
  watch: {
    model: {
      handler(value) {
        this.$emit('update:validation', value);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
